import $ from 'jquery';

export default function scroll() {
  let lastScrollTop = 500;
  $(window).scroll(function() {
    //console.log(lastScrollTop);
    let start = $(this).scrollTop();

    if (start > 150) {
      let st = $(this).scrollTop();
      if (st > lastScrollTop) {
        $('.header').removeClass('is-show');
        // $('.contact-bar').addClass('is-show');
        // $('.to-top').addClass('to-top--visible');
      } else {
        $('.header').addClass('is-show');
        // $('.contact-bar').removeClass('is-show');
        // $('.to-top').removeClass('to-top--visible');
      }
      lastScrollTop = st;

    } else if (start > 50) {
      $('.header').removeClass('is-show');
      $('.contact-bar').addClass('is-show');
      $('.to-top').addClass('to-top--visible');
    } else if (start < 50) {
        $('.header').addClass('is-show');
        $('.contact-bar').removeClass('is-show');
        $('.to-top').removeClass('to-top--visible');
    }

  });
}



